module.exports = __webpack_public_path__ + "img/icon-top-arrow.14a6e0a9.svg";